<template>
    <div>
        <div id="canvas" style="height: 300px;background-color: cornflowerblue; border:none"></div>
    </div>
</template>

<script>
    import Bpmn from "../../../../public/plugin/bpmn/bpmn";

    import axios from "axios/index";
    var BpmnViewer = require('bpmn-js').Viewer;

    import path from "../../../router/paths";

    export default {
        name: 'task-diagram',
        components: {},
        inheritAttrs: true,
        props: {
            processInstanceId: {
                type: String,
                default: null
            },
        },
        created() {
        },

        mounted() {
            Bpmn.initViewer("#canvas");
            this.loadDiagramOfTask();
        },

        destroyed() {
        },

        watch: {
            processInstanceId: function (data) {
                this.loadDiagramOfTask();
            }
        },

        data: () => {
            return {
                values: {},
                startValue: {},
                show: false,
                currentPage: 1,
                lstModel: [],
                showHistory: false,
                historyItems: [],
                formProperties: {},
                formComponent: null,
                totalRows: 0,
                fields: [
                    {value: "index", text: "Index", sortable: false, width: "5%"},
                    {value: 'name', text: 'Activity Name', sortable: false, width: "30%"},
                    {value: 'assignnee', text: 'Assignnee', sortable: false, width: "30%"},
                    {
                        value: 'createDate',
                        text: 'Create Date',
                        sortable: false,
                        dateFormat: 'dd/MM/yyyy hh:mm',
                        width: "10%"
                    },
                    {value: 'endTime', text: 'End Time', sortable: false, dateFormat: 'dd/MM/yyyy hh:mm', width: "5%"},
                    {value: 'View', text: "View", sortable: false, compound: true, width: "10%"}
                ],
                pageSize: 5,
                tabs: ""
            }
        },
        methods: {
            loadDiagramOfTask() {
                axios.post(process.env.VUE_APP_API_URL + '/task/getTaskModelByProcessInstanceId?processInstanceId=' + this.processInstanceId).then(data => {
                    Bpmn.loadViewer(data, null);
                    this.loadWorkingTask();
                }, error => {
                });
            },

            loadWorkingTask(){
                axios.post(process.env.VUE_APP_API_URL + '/task/workingTask?processInstanceId=' + this.processInstanceId).then(data => {
                    for(let i=0;i<data.length;i++){
                        let task = data[i];
                        console.log(task);
                        Bpmn.updateProcessingTask(task.taskDefinitionKey);
                    }
                }, error => {
                });
            },

            loadFinishedTask(){
                axios.post(process.env.VUE_APP_API_URL + '/task/workingTask?processInstanceId=' + this.processInstanceId).then(data => {
                    for(let i=0;i<data.length;i++){
                        let task = data[i];
                        console.log(task);
                        Bpmn.updateProcessingTask(task.taskDefinitionKey);
                    }
                }, error => {
                });
            },

            viewFromProcessInstanceId: function (processInstanceId) {
                axios.post(process.env.VUE_APP_API_URL + "/task/workingTask?processInstanceId=" + processInstanceId).then(
                    data => {
                        this.onView(data[0]);
                    }
                );

            },

            onView: function (value) {
                this.show = true;
                this.values = value;
                console.log(value);
                this.loadDiagramOfTask(value["processDefinitionId"], value["taskDefinitionKey"]);
                this.loadTaskHistory();
                //
                // clear form
                //
                this.lstModel = [];
                this.formComponent = null;
                this.formProperties = {};
                this.startValue = {};
                //
                // load form config and data
                //
                axios.post(process.env.VUE_APP_API_URL + "/task/getStartFormKey?processDefinitionId=" + value["processDefinitionId"]).then(
                    data => {
                        //console.log("form code:"+data);
                        if (data == null || data == undefined || data == "") {
                            //
                            // form is null
                            //
                        } else {
                            axios.post(process.env.VUE_APP_API_URL + "/form/getByCode?formCode=" + data).then(
                                form => {
                                    //console.log(form.formConfig);
                                    FormGenerator.loadFormModel(FormGenerator.decodeHTML(form.formConfig), "formProcess");
                                    this.formProperties = FormGenerator.toFormProperties();
                                    //console.log(this.formProperties);
                                    if (this.formProperties.component == undefined || this.formProperties.component == "") {
                                        this.lstModel = FormGenerator.modelToInputProperties();

                                        for (let i = 0; i < this.lstModel.length; i++) {
                                            if (this.lstModel[i].type == "Component") {
                                                //console.log(this.lstModel[i].properties["componentName"]);
                                                this.lstModel[i].component = this.getComponentByName(this.lstModel[i].properties["componentName"]);
                                                try {
                                                    //console.log(this.lstModel[i].properties["properties"]);
                                                    if (this.lstModel[i].properties["properties"] != undefined && this.lstModel[i].properties["properties"] != null && this.lstModel[i].properties["properties"] != "") {
                                                        let properties = JSON.parse(this.lstModel[i].properties["properties"]);
                                                        for (let key in properties) {
                                                            this.lstModel[i].properties[key] = properties[key];
                                                        }
                                                    }
                                                    //console.log(this.lstModel[i]);
                                                } catch (e) {
                                                    console.log(e);
                                                }
                                            }
                                        }

                                        axios.post(process.env.VUE_APP_API_URL + "/task/taskWorkingVariables?taskId=" + this.values["executionId"]).then(
                                            data => {
                                                //FormGenerator.loadInputData(data);
                                                //console.log(data);
                                                this.startValue = data;
                                                for (let property in data) {
                                                    if (typeof data[property] == "object") {
                                                        for (let childp in data[property]) {
                                                            this.startValue[property + "." + childp] = data[property][childp];
                                                        }
                                                    }
                                                }
                                            },
                                            error => {

                                            }
                                        );
                                    } else {
                                        //console.log("component form");
                                        this.lstModel = [];
                                        try {
                                            let componentName = this.formProperties.component;
                                            for (let i = 0; i < path.length; i++) {
                                                if (componentName == path[i].name) {
                                                    this.formComponent = path[i].component;
                                                    break;
                                                }
                                            }
                                        } catch (e) {
                                            console.log(e);
                                        }
                                    }
                                },
                                error => {
                                }
                            );
                        }
                    },
                    error => {

                    }
                )

            },

            viewTaskData: function (item) {
                let form = VueController.getComponentByComponentName("form-input");
                form.viewTaskData(item["formKey"], item["executionId"], item["id"]);
            }
        }
    }
</script>
